"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var TokensManager = /*#__PURE__*/function () {
  function TokensManager(options) {
    (0, _classCallCheck2.default)(this, TokensManager);
    (0, _defineProperty2.default)(this, "options", {});
    var accessTokenName = options.accessTokenName,
        refreshTokenName = options.refreshTokenName,
        secureCookies = options.secureCookies,
        cookiesDomain = options.cookiesDomain,
        rememberPeriod = options.rememberPeriod;
    this.options = {
      accessTokenName: accessTokenName,
      refreshTokenName: refreshTokenName,
      secureCookies: secureCookies,
      cookiesDomain: cookiesDomain,
      rememberPeriod: rememberPeriod
    };
  }

  (0, _createClass2.default)(TokensManager, [{
    key: "getAccessToken",
    value: function getAccessToken() {
      return _jsCookie.default.get(this.options.accessTokenName);
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return _jsCookie.default.get(this.options.refreshTokenName);
    }
  }, {
    key: "saveAccessToken",
    value: function saveAccessToken(token) {
      _jsCookie.default.set(this.options.accessTokenName, token, {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      });
    }
  }, {
    key: "saveRefreshToken",
    value: function saveRefreshToken(token) {
      var remember = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var options = {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      };

      if (remember) {
        options.expires = this.options.rememberPeriod;
      }

      _jsCookie.default.set(this.options.refreshTokenName, token, options);
    }
  }, {
    key: "saveTokens",
    value: function saveTokens(_ref) {
      var accessToken = _ref.accessToken,
          refreshToken = _ref.refreshToken;
      this.saveAccessToken(accessToken);
      this.saveRefreshToken(refreshToken);
    }
  }, {
    key: "removeTokens",
    value: function removeTokens() {
      _jsCookie.default.remove(this.options.accessTokenName, {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      });

      _jsCookie.default.remove(this.options.refreshTokenName, {
        secure: this.options.secureCookies,
        domain: this.options.cookiesDomain
      });
    }
  }]);
  return TokensManager;
}();

exports.default = TokensManager;
//# sourceMappingURL=tokens-manager.js.map